import React from 'react';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../constants/colors';
import HostForm from '../../components/HostForm';

const Host = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '10px 20px',
            backgroundColor: colors.dark_blue,
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          ⬅ Go to Home Page
        </button>
      </div>

      <h1 style={{ textAlign: 'center', fontSize: '32px', fontWeight: 'bold', marginBottom: '10px' }}>
        Become a Host
      </h1>

      <p style={{ textAlign: 'center', fontSize: '16px', color: '#555', marginBottom: '30px' }}>
        Fill out the form below and join our growing community of local hosts!
      </p>

      <HostForm />

      <p style={{ textAlign: 'center', fontSize: '14px', color: '#888', marginTop: '30px' }}>
        Have questions? Contact us at <a href="mailto:info@eventyol.org" style={{ color: colors.dark_blue }}>info@eventyol.org</a>
      </p>
    </div>
  );
};

export default Host;
